<template>
  <b-overlay :show="loading">
    <b-card no-body class="border-0 shadow-none">
      <b-card-body>
        <b-row class="align-items-center mb-1">
          <b-col cols="12" md>
            <h5 class="mb-25">Stok Mobil</h5>
            <p class="text-body mb-0">
              Pilih barang yang akan dikembalikan ke gudang, lalu isi jumlah
              pengembalian (minimal 1).
            </p>
          </b-col>
          <b-col cols="12" md="auto" class="mt-1 mt-md-0">
            <b-button
              v-if="isSales"
              variant="primary"
              :disabled="checkedBarangs.length < 1 || loading"
              @click.prevent="returnBarang"
            >
              <feather-icon icon="CornerUpRightIcon" class="mr-50" />
              Request Pengembalian Stok
              <b-badge
                v-if="checkedBarangs.length"
                variant="light-primary"
                class="ml-50"
              >
                {{ checkedBarangs.length }}
              </b-badge>
            </b-button>
          </b-col>
        </b-row>

        <b-row class="align-items-end mb-1">
          <b-col md="3" sm="6" class="my-1">
            <b-form-group label="Per halaman" label-for="perPageSelect" class="mb-0">
              <b-form-select
                id="perPageSelect"
                v-model="perPage"
                size="sm"
                :options="pageOptions"
              />
            </b-form-group>
          </b-col>
          <b-col md="5" sm="6" class="my-1">
            <b-form-group label="Cari" label-for="filterInput" class="mb-0">
              <b-input-group size="sm">
                <b-form-input
                  id="filterInput"
                  v-model="filter"
                  type="search"
                  placeholder="Cari nama / kode barang..."
                />
                <b-input-group-append>
                  <b-button :disabled="!filter" @click="filter = ''">
                    Clear
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>

        <div
          v-if="!loading && !items.length"
          class="text-center text-muted py-4 border rounded"
        >
          Belum ada stok di mobil.
        </div>

        <b-table
          v-show="loading || items.length"
          striped
          hover
          responsive
          small
          show-empty
          empty-text="Tidak ada data"
          :per-page="perPage"
          :current-page="currentPage"
          :items="items"
          :fields="fields"
          :filter="tableFilter"
          :filter-included-fields="filterOn"
          @filtered="onFiltered"
        >
          <template #head(checkbox)>
            <b-form-checkbox
              v-if="isSales"
              v-model="allChecked"
              :disabled="selectableItems.length < 1"
            />
            <span v-else>#</span>
          </template>

          <template #cell(checkbox)="{ item }">
            <b-form-checkbox
              v-if="isSales && item.stok > 0"
              v-model="checkedBarangs"
              :value="item"
            />
            <feather-icon
              v-else-if="isSales"
              icon="SlashIcon"
              class="text-danger"
            />
          </template>

          <template #cell(no)="{ index }">
            {{ (currentPage - 1) * perPage + index + 1 }}
          </template>

          <template #cell(kode)="{ item }">
            {{ item.kode || "-" }}
          </template>

          <template #cell(kategori)="{ item }">
            {{ item.kategori || "-" }}
          </template>

          <template #cell(satuan)="{ item }">
            {{ formatSatuan(item) }}
          </template>

          <template #cell(stok)="{ item }">
            <strong>{{ formatQty(item.stok) }}</strong>
          </template>

          <template #cell(jumlah_retur)="{ item }">
            <template v-if="item.stok > 0">
              <b-form-input
                v-model.number="item.jumlah_retur"
                type="number"
                size="sm"
                min="1"
                :max="Number(item.stok)"
                :state="qtyState(item)"
                @input="clampQty(item)"
              />
              <small
                v-if="qtyError(item)"
                class="text-danger d-block"
              >
                {{ qtyError(item) }}
              </small>
            </template>
            <small v-else class="text-danger">Stok kosong</small>
          </template>
        </b-table>

        <div
          class="d-flex justify-content-between align-items-center mt-1"
        >
          <small class="text-muted">Total {{ totalRows }} barang</small>
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="right"
            size="sm"
            class="my-0"
          />
        </div>
      </b-card-body>

      <retur-modal
        :items="checkedBarangs"
        :saving="loading"
        @submit="submit"
      />
    </b-card>
  </b-overlay>
</template>

<script>
import {
  BRow,
  BCol,
  BOverlay,
  BInputGroup,
  BInputGroupAppend,
  BBadge,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BButton,
  BCard,
  BCardBody,
  BTable,
  BFormCheckbox,
  BPagination,
} from "bootstrap-vue";
import ReturModal from "./Modal.vue";

export default {
  components: {
    BOverlay,
    BCard,
    BCardBody,
    ReturModal,
    BInputGroupAppend,
    BFormCheckbox,
    BTable,
    BPagination,
    BInputGroup,
    BButton,
    BRow,
    BCol,
    BBadge,
    BFormGroup,
    BFormInput,
    BFormSelect,
  },
  data() {
    return {
      loading: false,
      checkedBarangs: [],
      items: [],
      perPage: 10,
      pageOptions: [10, 30, 50, 100],
      totalRows: 0,
      currentPage: 1,
        filter: null,
      filterOn: ["nama", "kode", "kategori"],
      fields: [
        { key: "no", label: "No" },
        { key: "kode", label: "Kode" },
        { key: "kategori", label: "Kategori" },
        { key: "nama", label: "Nama Barang" },
        { key: "satuan", label: "Satuan" },
        { key: "stok", label: "Stok" },
      ],
      swalOptions: {
        title: "Request Pengembalian Stok Mobil?",
        text: "Request pengembalian akan dikirim ke Gudang Penyimpanan",
        icon: "info",
        showCancelButton: true,
        confirmButtonText: "Ya",
        cancelButtonText: "Batal",
        customClass: {
          confirmButton: "btn btn-outline-success",
          cancelButton: "btn btn-danger ml-1",
        },
        buttonsStyling: false,
      },
    };
  },
  computed: {
    salesId() {
      return this.$store.getters["gudang/findVehicle"](this.$route.params.id);
    },
    selectableItems() {
      return this.items.filter((item) => Number(item.stok) > 0);
    },
    allChecked: {
      get() {
        return (
          this.selectableItems.length > 0 &&
          this.checkedBarangs.length === this.selectableItems.length
        );
      },
      set(val) {
        if (val) {
          this.checkedBarangs = this.selectableItems.slice();
          this.checkedBarangs.forEach((item) => this.ensureQty(item));
        } else {
          this.checkedBarangs = [];
        }
      },
    },
    baseFields() {
      const cols = [
        { key: "no", label: "No" },
        { key: "kode", label: "Kode" },
        { key: "kategori", label: "Kategori" },
        { key: "nama", label: "Nama Barang" },
        { key: "satuan", label: "Satuan" },
        { key: "stok", label: "Stok" },
      ];
      if (this.isSales) {
        return [{ key: "checkbox", label: "" }, ...cols];
      }
      return cols;
    },
    returnFields() {
      return [
        { key: "checkbox", label: "" },
        { key: "nama", label: "Nama Barang" },
        { key: "satuan", label: "Satuan" },
        { key: "stok", label: "Stok" },
        { key: "jumlah_retur", label: "Qty Pengembalian" },
      ];
    },
    tableFilter() {
      const value = this.filter;
      if (value === null || value === undefined) return undefined;
      const trimmed = String(value).trim();
      return trimmed || undefined;
    },
  },
  watch: {
    checkedBarangs(items) {
      this.fields = items.length > 0 ? this.returnFields : this.baseFields;
    },
  },
  methods: {
    formatSatuan(item) {
      if (!item || item.satuan === null || item.satuan === undefined || item.satuan === "") {
        return "-";
      }
      if (item.satuan && typeof item.satuan === "object") {
        return item.satuan.satuan || "-";
      }
      return item.satuan;
    },
    formatQty(value) {
      const n = Number(value);
      if (Number.isNaN(n)) return value || 0;
      return n.toLocaleString("id-ID");
    },
    ensureQty(item) {
      const stok = Number(item.stok) || 0;
      const qty = Number(item.jumlah_retur);
      if (!qty || qty < 1) {
        this.$set(item, "jumlah_retur", stok > 0 ? stok : 1);
      }
    },
    clampQty(item) {
      const stok = Number(item.stok) || 0;
      let qty = Number(item.jumlah_retur);
      if (Number.isNaN(qty) || qty === null) {
        this.$set(item, "jumlah_retur", "");
        return;
      }
      if (qty < 0) qty = 0;
      if (qty > stok) qty = stok;
      this.$set(item, "jumlah_retur", qty);
    },
    qtyError(item) {
      if (!this.checkedBarangs.includes(item)) return "";
      const qty = Number(item.jumlah_retur);
      const stok = Number(item.stok) || 0;
      if (!qty || qty < 1) return "Minimal 1";
      if (qty > stok) return `Maksimal ${stok}`;
      return "";
    },
    qtyState(item) {
      if (!this.checkedBarangs.includes(item)) return null;
      return this.qtyError(item) ? false : true;
    },
    validateCheckedQty() {
      const invalid = this.checkedBarangs.filter((item) => {
        const qty = Number(item.jumlah_retur);
        const stok = Number(item.stok) || 0;
        return !qty || qty < 1 || qty > stok;
      });
      if (invalid.length) {
        this.displayError({
          message:
            "Qty pengembalian harus lebih dari 0 dan tidak melebihi stok.",
        });
        return false;
      }
      return true;
    },
    async submit(payload) {
      if (!this.validateCheckedQty()) return;

      const { pengembalian: pengembalianPayload, rincian, done } = payload;
      try {
        this.loading = true;
        const pengembalian = await this.$store.dispatch(
          "pengembalianbarang/save",
          [pengembalianPayload]
        );

        const payloads = rincian.map((payloadRincian) => {
          payloadRincian.id_pengembalian = pengembalian.id;
          return payloadRincian;
        });

        await this.$store.dispatch("pengembalianbarang/saveRincian", payloads);
        this.checkedBarangs = [];
        if (typeof done === "function") done();
        this.$emit("submitRetur", pengembalian);
      } catch (e) {
        this.displayError(e);
      } finally {
        this.loading = false;
      }
    },
    returnBarang() {
      if (!this.validateCheckedQty()) return;
      this.checkedBarangs.forEach((item) => this.ensureQty(item));
      this.$swal(this.swalOptions).then((res) => {
        if (res.value) {
          this.$bvModal.show("retur-modal");
        }
      });
    },
    async getData() {
      try {
        this.loading = true;
        // Prefer gudang mobil dari route detail; fallback myGudang / vehicle store
        const id_gudang =
          this.$route.params.id ||
          (this.myGudang && this.myGudang.id) ||
          (this.salesId && this.salesId.id);

        if (!id_gudang) {
          this.items = [];
          this.totalRows = 0;
          return;
        }

        const result = await this.$store.dispatch("gudang/getDataStokMobil", {
          order: "desc",
          id_gudang,
        });

        const fromStore = this.$store.state.gudang.stokMobil;
        const rows = Array.isArray(result)
          ? result
          : Array.isArray(fromStore)
            ? fromStore
            : [];

        this.items = rows.map((item) => ({
          ...item,
          jumlah_retur: Number(item.stok) > 0 ? Number(item.stok) : "",
        }));
        this.totalRows = this.items.length;
        this.currentPage = 1;
        this.checkedBarangs = [];
        this.filter = null;
        this.setFields();
      } catch (e) {
        this.displayError(e);
        this.items = [];
        this.totalRows = 0;
      } finally {
        this.loading = false;
      }
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    setFields() {
      this.fields = this.baseFields;
    },
  },
  created() {
    this.setFields();
    this.getData();
  },
};
</script>
